import PropTypes from 'prop-types';
import React from 'react';

import Can from '../../../security/Can';
import ItemMenu from '../ItemMenu';
import { SubMenuCustom } from './styles';

const SubMenuItem = props => {
  const {
    user,
    menu,
    onClickMenu,
    isTabletOrMobile,
    collapsed,
    ...defaultProperties
  } = props;

  return (
    <Can
      key={menu.id}
      profile={user.profile}
      permissions={user.permissions}
      perform={menu.permissoes_que_habilitam_menu}
      data={menu.data}
      yes={() => (
        <SubMenuCustom
          key={menu.id}
          title={menu.name}
          icon={menu.icon}
          {...defaultProperties}
        >
          {menu.menus.map(sub => (
            <ItemMenu
              menu={sub}
              user={user}
              key={sub.id}
              onClickMenu={onClickMenu}
              isTabletOrMobile={isTabletOrMobile}
              collapsed={collapsed}
            />
          ))}
        </SubMenuCustom>
      )}
    />
  );
};

SubMenuItem.propTypes = {
  user: PropTypes.shape({
    profile: PropTypes.string,
    permissions: PropTypes.array,
  }).isRequired,
  menu: PropTypes.shape({
    id: PropTypes.number,
    icon: PropTypes.element,
    name: PropTypes.string,
    breakLine: PropTypes.bool,
    url: PropTypes.string,
    permissoes_que_habilitam_menu: PropTypes.any,
    data: PropTypes.any,
    menus: PropTypes.any,
  }).isRequired,
  onClickMenu: PropTypes.func.isRequired,
  isTabletOrMobile: PropTypes.bool.isRequired,
  collapsed: PropTypes.bool.isRequired,
};

export default SubMenuItem;
